import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ documentId }) =>
    present(
      repository
        .retrieveDocumentKey(documentId)
        .then((key) => ({
          documentId,
          key:
            key.attributes && key.attributes.key
              ? key.attributes.key.replace(/:/g, "")
              : documentId,
        }))
        .catch(() => Promise.reject({ documentId })),
    );
}

export type { Interactor };

export { createInteractor };
